import React from 'react';

export interface LoaderProps {
  isLoading: boolean;
  text?: string;
  inline?: boolean;
}

/** @deprecated - Please use the [GfLoader](../gfcomponents/GfLoader/GfLoader.tsx) component instead */
export default function Loader({ isLoading, text, inline }: LoaderProps) {
  if (inline) {
    return isLoading ? <div className="ui active centered inline loader">{text}</div> : null;
  }

  return isLoading ? (
    <div className="ui active inverted dimmer">
      <div className="ui loader">
        <div className="loader-text">{text}</div>
      </div>
    </div>
  ) : null;
}
